import { Router } from '@angular/router';

/**
 * Builds a fully qualified, shareable URL for the given router commands.
 *
 * `Router.serializeUrl` produces an app-absolute path (`/proposal/flow/xxx`) that
 * ignores the base href. The base href carries the i18n locale (`/` for fr, `/en/`
 * for en), so it has to be re-applied for the link to work outside of the current
 * locale's build.
 */
export function buildAbsoluteUrl(
  router: Router,
  baseHref: string,
  commands: unknown[]
): string {
  const path = router.serializeUrl(router.createUrlTree(commands));
  const normalizedBase = baseHref.endsWith('/') ? baseHref : `${baseHref}/`;

  return new URL(
    `${normalizedBase}${path.replace(/^\//, '')}`,
    window.location.origin
  ).toString();
}

/**
 * Only app-internal paths are safe to redirect to after login. Anything
 * protocol-relative (`//evil.com`) or absolute would be an open redirect.
 */
export function isSafeReturnUrl(url: string | null | undefined): url is string {
  return !!url && url.startsWith('/') && !url.startsWith('//');
}
